export const APP_STORE_URL = 'https://apps.apple.com/app/id1637609333'

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.teevee.mobile'

export const TELLY_WEBSITE_URL = 'https://www.telly.com'

const IOS_UA = /iPhone|iPad|iPod/i
const ANDROID_UA = /Android/i

/**
 * @description Whether the visitor is on a platform that can open a `telly://`
 * link at all. Desktop browsers show an "unsupported protocol" dialog instead,
 * so the redirect-only pages must not fire their deeplink there.
 */
export const isMobileUserAgent = (userAgent: string): boolean =>
  IOS_UA.test(userAgent) || ANDROID_UA.test(userAgent)

export const getAppStoreFallbackUrl = (userAgent: string): string =>
  IOS_UA.test(userAgent) ? APP_STORE_URL : PLAY_STORE_URL

/**
 * @description Platform-aware download destination: App Store on iOS,
 * Play Store on Android, telly.com everywhere else (desktop, bots).
 */
export const getDownloadUrl = (userAgent: string): string => {
  if (IOS_UA.test(userAgent)) {
    return APP_STORE_URL
  }
  if (ANDROID_UA.test(userAgent)) {
    return PLAY_STORE_URL
  }
  return TELLY_WEBSITE_URL
}
